import { TokenExpired } from 'components/tokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks';
import { RuleManagement } from 'pages/rules';

export const RuleManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('rules');

  return isExpired ? (
    <TokenExpired />
  ) : canAccess || isAdmin ? (
    <RuleManagement />
  ) : (
    <Unauthorized />
  );
};
